var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$s.quoteBox},[_c('o-heading',{class:_vm.$s.quote},[_vm._v("\n    "+_vm._s(_vm.pageData.quote.text)+"\n  ")]),_c('o-heading',{attrs:{"size":"title-5"}},[_vm._v("\n    "+_vm._s(_vm.pageData.quote.quoteAttributor)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }